import posthog from 'posthog-js';

// PostHog is env-gated: with no key set, every call is a safe no-op, so the app
// runs identically before the key lands (mirrors how the Anthropic key works).
// Set VITE_POSTHOG_KEY (the public "Project API Key", phc_…) and optionally
// VITE_POSTHOG_HOST (US: https://us.i.posthog.com, EU: https://eu.i.posthog.com).
const KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const HOST = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) || 'https://us.i.posthog.com';

let enabled = false;

export function initAnalytics(): void {
  if (enabled || !KEY) return;
  posthog.init(KEY, {
    api_host: HOST,
    capture_pageview: false,   // SPA: we capture $pageview manually on route change
    capture_pageleave: true,
    // Privacy-friendlier + cheaper: only anonymous visitors are counted for
    // traffic; full person profiles are created only once a user logs in.
    person_profiles: 'identified_only',
  });
  enabled = true;
}

export function trackPageview(): void {
  if (enabled) posthog.capture('$pageview');
}

// Product event. Keep props non-sensitive (counts/types/flags) — never raw
// ticket text, query text, or other customer data.
export function captureEvent(name: string, props?: Record<string, unknown>): void {
  if (enabled) posthog.capture(name, props);
}

export function identifyUser(id: string, props?: Record<string, unknown>): void {
  if (enabled) posthog.identify(id, props);
}

// B2B grouping — ties events/sessions to the organization for later product
// analytics (retention/usage per customer), not just per individual.
export function setOrgGroup(orgId: string, orgName?: string): void {
  if (enabled) posthog.group('organization', orgId, orgName ? { name: orgName } : undefined);
}

export function resetAnalytics(): void {
  if (enabled) posthog.reset();
}
